import { api } from 'data/api/api'

import { HandleRefundOfferActionArgs } from '../types/handle-refund-offer-action'

export const handleRefundOffer = ({ refundOfferId, action }: HandleRefundOfferActionArgs) =>
  api.post(`/refund_offers/${refundOfferId}/${action}`)
